import { fetchData } from '../utils';
import { ApiResponse } from '../types';
import { OFFLINE } from './setup';

export const getAdvertisers = async (countryISO: string) => {
  return fetchData<ApiResponse<string[]>>(
    `/${OFFLINE}/advertisers?countryISO=${countryISO}`
  );
};
